module.exports = "<section-header contents=\"{\n    state: $ctrl.contents.state,\n    iconClass: 'fa-exchange',\n    title: 'The basics',\n    description: 'Keep track of transactions, invoices and travels - the basis of everything here.'\n}\"></section-header> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/3-basics/basics.section-header.html
// module id = 4092
// module chunks = 86